// create new array for countries and appending a new object that represents default value
const countries = [
    {
        country: 'Select A Country',
        countryId: '',
        regionCode: '',
        countryCode: ''
    },
    ...window.sandals_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [
    ...window.sandals_app.page.states
];

import CustomDatepicker from '~/js/components/form-controls/CustomDatepicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import FileImageUpload from '~/js/components/form-controls/FileImageUpload';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

ReactDOM.render(
    <CountryStateSelector
        countries={ countries }
        states={ states }
        countryName="countryCode"
        stateName="state"
        stateLabelWrapper="col-sm-5"
        stateInputWrapper="col-sm-7"
        countryLabelWrapper="col-sm-5"
        countryInputWrapper="col-sm-7"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <CustomDatepicker
        name="checkInDate"
        wrapperClassName="col-xs-12 col-sm-7"
        inputClassName="checkin-date-input"
        isRequired
        allowPast
        displayPlaceHolder
        displayStringDate={false}
    />,
    document.getElementById('checkin-datepicker')
);

ReactDOM.render(
    <FileImageUpload
        fileSizeLimit={ 3 }
        isRequired
        name="document"
        btnMessage="CHOOSE FILE"
        displaySelectedFileName
    />,
    document.getElementById('upload-file')
);

ReactDOM.render(
    <CustomRecaptcha
        wrapperClassName="col-xs-12 col-sm-6 col-sm-offset-3"
    />,
    document.getElementById('google-recaptcha')
);

// form validations
import '~/js/modules/fend';

// form elements references
const $landlineNumber = $('#landLineNumber');
const $mobileNumber = $('#mobileNumber');
// const $countrySelector = $('select[name="countryCode"]');
// const $subscribeLabel = $('.form-label[for="subscribe"]');
const $resortSelect = $('select[name="resort"]');
const $checkInDate = $('input[name="checkInDate"]');
const $submitButton = $('#submit-button');
const $freeAnniversaryForm = $('.free-anniversary-form');

// Form Validation
$freeAnniversaryForm.fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        bookingNumber: 'alphanumeric',
        city: 'lettersOnly'
    }
});

$landlineNumber.change( function validateNumber() {
    if (this.value) {
        $mobileNumber.removeAttr('required');
        $mobileNumber.trigger( 'blur' );
    }else {
        $mobileNumber.attr('required', true);
    }
});

$mobileNumber.change( function validateNumber() {
    if (this.value) {
        $landlineNumber.removeAttr('required');
        $landlineNumber.trigger( 'blur' );
    }else {
        $landlineNumber.attr('required', true);
    }
});

// $subscribeLabel.text($subscribeLabel.data('normal'));

// $countrySelector.on('change', (event) => {
//     const countryId = event.target.value;

//     $subscribeLabel.text($subscribeLabel.data('normal'));

//     if (countryId === 'CA') {
//         $subscribeLabel.html($subscribeLabel.data('canada'));
//     }
// });

$submitButton.click( () => {
    const $actualResort = $resortSelect.val();
    const $actualDate = $checkInDate.val();

    $freeAnniversaryForm.attr('data-location', '/en/free-anniversary-thank-you/?resortName=' + $actualResort + '&checkInDate=' + $actualDate);
});

$(document).ready( () => {
    if ($landlineNumber.val()) {
        $mobileNumber.removeAttr('required');
        $mobileNumber.trigger( 'blur' );
    }

    if ($mobileNumber.val()) {
        $landlineNumber.removeAttr('required');
        $landlineNumber.trigger( 'blur' );
    }
});

